export default __webpack_public_path__ + "static/media/995.5cfbd230.png";